import { Project, CareerItem, ProfileData } from '../types';

export const INITIAL_PROFILE: ProfileData = {
  "nameKanji": "岩本 佑都",
  "nameRomaji": "YUTO IWAMOTO",
  "roleTitle": "Creator / Developer / Innovator",
  "tagline": "星のあいだに、制作の軌跡を。",
  "bio": "Miyazaki frogs 2期生（AKATSUKI プロジェクト 2025 採択）。WRO Japan ロボット競技での全国大会出場、MJSA宇宙コース・宇宙線クラスでの探究、映像制作『君の52Hzが聞こえた廊下で』、NIE運動でのクロストークパネリストなど、テクノロジー・サイエンス・映像表現を横断して活動中。",
  "vision": "宮崎から世界へ。ロボット工学やプログラミングの論理と、映像や宇宙サイエンスの感性を融合し、人に深く届くクリエイティブを探求しています。",
  "photoUrl": "/profile_avatar.jpg",
  "location": "宮崎県 / Miyazaki, Japan",
  "email": "yuto.iwamoto.work@gmail.com",
  "githubUrl": "https://github.com/tuuchan252525cat-afk/",
  "xUrl": "https://x.com",
  "instagramUrl": "https://www.instagram.com/yuto.2525727/",
  "facebookUrl": "https://www.facebook.com/profile.php?id=61577826275908",
  "frogsCohort": "Miyazaki frogs 2期 (2025)"
};

export const INITIAL_CAREER: CareerItem[] = [
  {
    "id": "miyazaki-frogs",
    "period": "2025",
    "title": "Miyazaki frogs 2期 / AKATSUKI プロジェクト 採択",
    "organization": "一般社団法人 MIYAZAKI frogs / AKATSUKI プロジェクト",
    "role": "2期生選抜生 / プロダクト起業家育成プログラム",
    "description": "宮崎から世界を変える若手イノベーター育成プログラム「Miyazaki frogs 2期」に選抜。「AKATSUKI プロジェクト 2025」に採択され、社会課題の探究からテクノロジーを用いたイノベーション創出・ピッチ発表を実践。",
    "highlights": [
      "AKATSUKI プロジェクト 2025 採択",
      "顧客課題・地域課題の徹底的なフィールドワークと仮説検証",
      "リーンスタートアップ手法によるプロトタイピングとプレゼンテーション",
      "シリコンバレー研修・各種メンターセッションによるアントレプレナーシップの深化"
    ],
    "skills": [
      "AKATSUKIプロジェクト採択",
      "Design Thinking",
      "アントレプレナーシップ",
      "Problem Solving",
      "Pitch Presentation"
    ],
    "isHighlighted": true
  },
  {
    "id": "wro-japan",
    "period": "2024 - 2026",
    "title": "WRO (World Robot Olympiad) Japan 南九州予選 連続準優勝・全国大会出場",
    "organization": "WRO Japan 南九州地区予選会",
    "role": "ロボット設計・プログラミング・制御エンジニア",
    "description": "自律型ロボットの国際競技会「WRO (World Robot Olympiad) Japan」南九州予選において、3年連続で準優勝を獲得。2025年には難関のエキスパート競技で準優勝し全国大会への出場を果たしました。",
    "highlights": [
      "2024年: ジュニア部門 ミドル競技 準優勝",
      "2025年: ジュニア部門 エキスパート競技 準優勝 →【全国大会出場】",
      "2026年: シニア部門 エキスパート競技 準優勝",
      "カラーセンサー、ジャイロセンサーを駆使した自律走行アルゴリズムおよびアーム機構の設計・開発"
    ],
    "skills": [
      "自律型ロボット工学",
      "センサー制御",
      "アルゴリズム最適化",
      "全国大会出場",
      "Hardware & Software Integration"
    ],
    "isHighlighted": true
  },
  {
    "id": "mjsa-science",
    "period": "2025 - 2026",
    "title": "MJSA [みやざきジュニアサイエンスアカデミー] 宇宙コース・宇宙線クラス & ボランティア",
    "organization": "みやざきジュニアサイエンスアカデミー (MJSA)",
    "role": "宇宙コース 1st 修了生 / ロボット・プログラミングボランティア",
    "description": "科学的探究心を深めるMJSAにて宇宙線観測や宇宙物理を学ぶ「宇宙コース・宇宙線クラス 1st」を修了。2026年度には次世代の後輩たちを育成・サポートするプログラミングコース・ロボットクラスのボランティアとして活動。",
    "highlights": [
      "2025年: 宇宙コース・宇宙線クラス 1st 受講・修了（霧箱やセンサーを用いた宇宙線観測・宇宙科学の探究）",
      "2026年度: プログラミングコース・ロボットクラス ボランティア指導員として参加",
      "科学的アプローチによる実験データの収集・分析と、初学者へのロボットプログラミング伝達"
    ],
    "skills": [
      "宇宙科学 / 宇宙線観測",
      "科学探究",
      "メンター・ボランティア指導",
      "プログラミング教育"
    ],
    "isHighlighted": true
  },
  {
    "id": "video-production",
    "period": "2025 - 2026",
    "title": "動画制作作品『君の52Hzが聞こえた廊下で』",
    "organization": "Independent Creative Film Project",
    "role": "企画・監督・脚本・映像撮影・編集",
    "description": "誰にも届かない周波数（52ヘルツ）で鳴くクジラをモチーフに、思春期の静かな孤独と他者との微かな共鳴を描いた短編映像作品『君の52Hzが聞こえた廊下で』を制作。",
    "highlights": [
      "構図設計・カラーグレーディング・サウンドデザインの綿密な演出設計",
      "学校の廊下という日常の空間に光と影を巧みに配置した映像美の追求",
      "静謐なテンポと感情の揺らぎを捉えたカット割り・ストーリーテリング"
    ],
    "skills": [
      "映像制作 / ディレクション",
      "動画編集",
      "カラーグレーディング",
      "サウンドデザイン",
      "ストーリーテリング"
    ],
    "isHighlighted": true
  },
  {
    "id": "nie-movement",
    "period": "2025 - 2026",
    "title": "戦争 (NIE運動) / 第3回 NIE宮崎県大会 クロストークパネリスト",
    "organization": "日本新聞協会 NIE (Newspaper in Education) 宮崎県推進協議会",
    "role": "クロストークパネリスト / 登壇者",
    "description": "新聞を活用して社会課題や歴史・平和を学ぶ「NIE（教育に新聞を）運動」に参画。「第3回 NIE宮崎県大会」において、戦争の記憶の継承や現代における情報リテラシーについて高校生・ユース世代の視点からパネリストとしてクロストークに登壇。",
    "highlights": [
      "第3回 NIE宮崎県大会 クロストークセッション登壇",
      "「戦争の記憶と平和教育」「情報社会におけるメディアリテラシー」について発信",
      "多面的な視点から社会課題を捉え、自らの言葉で対話する表現力を発揮"
    ],
    "skills": [
      "NIE運動 (教育に新聞を)",
      "パネリスト登壇",
      "メディアリテラシー",
      "平和教育 / 戦争伝承",
      "パブリックスピーキング"
    ]
  },
  {
    "id": "miyazaki-hinata-tour",
    "period": "2025",
    "title": "みやざきひなたアドベンチャーツアー 2025",
    "organization": "宮崎県 フィールドワーク推進事業",
    "role": "参加メンバー / 地域探究フィールドワーク",
    "description": "宮崎県から、小中学生とともに科学技術を学びに大阪万博やカップヌードルミュージアムを訪問。新たな視点の探究を行った。",
    "highlights": [
      "小中学生とともに大阪万博を訪問し最先端の科学技術を探究",
      "カップヌードルミュージアムでの創造的思考・発明プロセスの学習",
      "宮崎から関西へのフィールドワークを通じた新たな視点の探究と実践"
    ],
    "skills": [
      "科学技術探究",
      "大阪万博",
      "カップヌードルミュージアム",
      "フィールドワーク",
      "創造的探究"
    ]
  }
];

export const INITIAL_PROJECTS: Project[] = [
  {
    "id": "film-52hz",
    "title": "君の52Hzが聞こえた廊下で",
    "year": "2025 - 2026",
    "category": "Video Production",
    "description": "誰にも届かない周波数で鳴く孤独と、学校の廊下で交錯する心の共鳴を描いた短編映像作品。",
    "longDescription": "「世界で最も孤独なクジラ」と呼ばれる52ヘルツの鳴き声をモチーフに、思春期の繊細な感情の揺らぎと他者との予期せぬ共鳴を映像化したオリジナル短編作品。自然光を活かした校舎の廊下の光と影、音の静寂と微かなノイズを意識し、言葉以上に雄弁な空気感を演出しました。",
    "tech": "Premiere Pro, DaVinci Resolve, 4K Cinema Camera, Sound Design",
    "image": "https://images.unsplash.com/photo-1536440136628-849c177e76a1?auto=format&fit=crop&w=1600&q=86",
    "imageAlt": "Quiet moody cinematic hallway with dramatic light",
    "link": "#career",
    "role": "企画・脚本・撮影・監督・編集",
    "client": "自主制作映像作品",
    "highlights": [
      "自然光と陰影のコントラストを際立たせたシネマティックなトーン設計",
      "環境音とオリジナルアンビエント音源による立体的な音響設計",
      "経歴掲載の代表的な動画制作プロジェクト"
    ],
    "galleryImages": [
      "https://images.unsplash.com/photo-1536440136628-849c177e76a1?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1506703719100-a0f3a48c0f86?auto=format&fit=crop&w=1200&q=80"
    ]
  },
  {
    "id": "wro-robotics",
    "title": "Autonomous Robotics Platform (WRO Japan)",
    "year": "2024 - 2026",
    "category": "Robotics & Control",
    "description": "WRO Japan南九州予選3年連続準優勝・全国大会出場を果たした自律型競技ロボットシステム。",
    "longDescription": "WRO Japanのエキスパート競技に向けて開発された高精度な自律制御ロボット。コース上のカラー識別、ライン追従、高精度マニピュレーターアームによるオブジェクト把持を、ミリ秒単位のフィードバック制御によって安定動作させ、全国大会出場を達成しました。",
    "tech": "C++, Python, Gyro/Color Sensors, PID Control, CAD Chassis Design",
    "image": "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1600&q=86",
    "imageAlt": "Futuristic robotics component",
    "link": "#career",
    "role": "メカ設計・アルゴリズム開発・ドライバー",
    "client": "WRO Japan South Kyushu / National Finals",
    "highlights": [
      "ジュニア部門 エキスパート競技 準優勝（全国大会進出）",
      "シニア部門 エキスパート競技 準優勝（2026）",
      "PID制御による高精度な自律走行と障害物回避アルゴリズム"
    ],
    "galleryImages": [
      "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=1200&q=80"
    ]
  },
  {
    "id": "cosmic-gallery",
    "title": "Cosmic Gallery",
    "year": "2026",
    "category": "Web Experience",
    "description": "星雲の奥行きと余白を活かした、作品閲覧のためのインタラクティブギャラリー。",
    "longDescription": "深宇宙をテーマにした没入型の作品アーカイブ。Three.jsとFramer Motionを組み合わせ、鑑賞者のポインター操作に連動して微細な星屑と光のグラデーションが揺らぐデジタルエクスペリエンスを設計しました。無機質になりがちなWebギャラリーに、温かみのある余白と静かな時間の流れを与えています。",
    "tech": "Next.js, Three.js, Framer Motion, Tailwind CSS",
    "image": "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?auto=format&fit=crop&w=1600&q=86",
    "imageAlt": "Nebula in deep space",
    "link": "https://portfolio-chatgptver.web.app",
    "role": "Design & Creative Coding",
    "client": "Self-initiated Project",
    "highlights": [
      "60fpsで安定動作する軽量なパーティクル演算エンジン",
      "視線誘導を意識した非同期エディトリアルレイアウト",
      "モバイル端末でのスムーズなジャイロ・スワイプ操作"
    ],
    "galleryImages": [
      "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1506703719100-a0f3a48c0f86?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1200&q=80"
    ]
  },
  {
    "id": "mjsa-cosmic-ray",
    "title": "Cosmic Ray Chamber & Sensor Archive",
    "year": "2025 - 2026",
    "category": "Science & Data",
    "description": "MJSA宇宙コース・宇宙線クラスにおける宇宙線飛跡観測とデータロギングプロジェクト。",
    "longDescription": "みやざきジュニアサイエンスアカデミー（MJSA）宇宙コース・宇宙線クラス1stにおいて実施した宇宙線（ミューオン）の霧箱観測およびセンサーデータ集計。宇宙から絶え間なく降り注ぐ不可視の粒子を可視化し、科学的探究レポートとして記録しました。",
    "tech": "Sensor Logging, Data Analysis, Python, Science Presentation",
    "image": "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1600&q=86",
    "imageAlt": "Cosmic particle visualization",
    "link": "#career",
    "role": "宇宙コース 1st 研究生",
    "client": "MJSA 宇宙コース",
    "highlights": [
      "宇宙線（ミューオン飛跡）の霧箱内リアルタイム観測",
      "2026年度プログラミングコース・ロボットクラス ボランティアでの実践指導"
    ],
    "galleryImages": [
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1506703719100-a0f3a48c0f86?auto=format&fit=crop&w=1200&q=80"
    ]
  },
  {
    "id": "orbit-studio",
    "title": "Orbit Studio",
    "year": "2025",
    "category": "Brand Website",
    "description": "ブランドの世界観を軌道のように巡らせる、モーション重視のWebサイト。",
    "longDescription": "クリエイティブエージェンシー「Orbit Studio」の公式ブランドサイト。天体の軌道力学からインスピレーションを受けた回転と浮遊のアニメーションを採用し、訪問者が直感的にプロジェクトを探検できるUIを構築しました。",
    "tech": "React, GSAP, Tailwind CSS, TypeScript",
    "image": "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=1600&q=86",
    "imageAlt": "Earth viewed from space",
    "link": "https://example.com/orbit-studio",
    "role": "Lead Frontend Engineer",
    "client": "Orbit Studio Inc.",
    "highlights": [
      "ブランドアイデンティティに沿ったオービット型ページナビゲーション",
      "アクセシビリティとアニメーションの両立（Prefers-reduced-motion対応）"
    ],
    "galleryImages": [
      "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1200&q=80"
    ]
  },
  {
    "id": "lunar-archive",
    "title": "Lunar Archive",
    "year": "2024",
    "category": "Editorial",
    "description": "月面探査の記録を、読むリズムと映像的な余白で再構成したデジタルアーカイブ。",
    "longDescription": "歴史的な月面探査ミッションのオープンデータを、現代的なデジタルエディトリアルとして再構築。縦組みタイポグラフィと水平スクロールのハイブリッド構造を採用し、文章と高解像度写真が織りなす静謐な読書体験を生み出しました。",
    "tech": "Astro, CSS Custom Properties, Contentful",
    "image": "https://images.unsplash.com/photo-1519608487953-e999c86e7452?auto=format&fit=crop&w=1600&q=86",
    "imageAlt": "Night sky above mountains",
    "link": "https://example.com/lunar-archive",
    "role": "Editorial Director & Front-end Dev",
    "client": "Cultural Heritage Project",
    "highlights": [
      "日本語の組版ルール（禁則処理・ルビ・約物）に厳格に則ったタイポグラフィ設定",
      "閲覧ペースに応じたパララックス背景演出"
    ],
    "galleryImages": [
      "https://images.unsplash.com/photo-1519608487953-e999c86e7452?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1506703719100-a0f3a48c0f86?auto=format&fit=crop&w=1200&q=80"
    ]
  }
];
